import { usePresetSafeMode } from '../../hooks/usePresetSafeMode';

export const NSFWAgeConfirmation = () => {
	usePresetSafeMode();

	return null;
};
